import React, {  Component } from 'react';
import { connect } from 'react-redux';
import {browserHistory} from 'react-router';
import _ from 'lodash';
import moment from 'moment';

/* Actions */
import {
	updateUserAccounts,
	saveUsersOfAccount,
	deleteUser,
	getOthersUserDetails,
	getUserLDAPEmail,
	updateAccountResponsibility,
	saveAccountResponsibility
	// getOthersLocalUserDetails
} from '../../../redux/actions';

import ProfileTabs from './ProfileTabs';
import OtherUserMyProfile from './OtherUserMyProfile';

/*Dialogs*/
import ConfirmDeleteUserDialogWithOptions from '../../dialogs/confirmDeleteUserDialogWithOptions';
import ConfirmManageUserDeleteUserDialogSuccess from '../../dialogs/confirmManageUserDeleteUserDialogSuccess';
import ConfirmUpdateManageUsersResposibilities from '../../dialogs/confirmUpdateManageUsersResposibilities';
import GenericOverlayDialog from '../../dialogs/genericOverlayDialog';
import { PNET_USER_ROLES } from '../../common/partsNetConstants';

class ManageUsers extends Component {

    constructor(props) {
        super(props);
        this.state = {
            updateMessage: false,
			errorMessage: '',
            showConfirmDeleteUserDialogWithOptions:false,
            showConfirmManageUserDeleteUserDialogSuccess:false,
            showConfirmUpdateManageUsersResposibilities:false,

			usersOfAccount: null,

			isDeleteCompleted: false,
			isUpdateUserAccountCompleted: false,

			otherUser: null,

			returns: 'ASMApprovalRequired',
			allowDealerReturnAccessErrorMessage: '',
			allowedCreditTypes: [],
			allowDealerCreditAccessErrorMessage: '',

			displaySA: 'Alphabetically',
			displaySalesAgreementErrorMessage: '',

			showGenericOverlayDialog: false,
			genericDialogHeading: '',
			genericDialogText: '',
		}
		this.handleResponsibilityChange = this.handleResponsibilityChange.bind(this);
		this.updateUsersOfAccountData = this.updateUsersOfAccountData.bind(this);
		this.resetResponsibilities = this.resetResponsibilities.bind(this);
		this.callBackAfterDeleteAndUpdateUserAccounts = this.callBackAfterDeleteAndUpdateUserAccounts.bind(this);
    }

    updateDetails(event) {
		event.preventDefault();

		const self = this,
			{ usersOfAccount } = self.state,
			{ selectedAccount } = self.props.state.user;

		self.handleDialog('ConfirmUpdateManageUsersResposibilities', false);

		self.setState({
			errorMessage: "",
			updateMessage: false
		});

		let accountRequests = [];

		usersOfAccount.responseObject.map(item => {
			const tempItm = JSON.parse(JSON.stringify(item));
			if(!_.isEqual(tempItm, _.find(self.props.state.user.usersOfAccount.responseObject, ['userId', item.userId]))) {
				const approvedAccounts = _.filter(item.accounts, {approvalStatus: 'Approved', accountNumber: selectedAccount.ACCOUNTNUMBER});
				if(approvedAccounts.length > 0 && !_.isEqual(item.accounts)) {
					accountRequests = accountRequests.concat(approvedAccounts);
				}
			}
			return null;
		});

		//After hiding make service call of registration
		self.props.updateUserAccounts(accountRequests, 'requestType=updateAccounts', response => {
			if(response.status) {
				self.setState({
					updateMessage: true
				});
				self.props.saveUsersOfAccount(JSON.parse(JSON.stringify(self.state.usersOfAccount)));
			} else {
				browserHistory.push("/error");
			}
		});
    }

	updateAccount(event){
        event.preventDefault();

		const self = this,
			{ usersOfAccount } = self.props.state.user,
			stateUsersOfAccount = self.state.usersOfAccount;

		self.setState({
			errorMessage: "",
			updateMessage: false
		})
		if(_.isEqual(stateUsersOfAccount, usersOfAccount)) {
			self.setState({
				errorMessage: "Please select at least one item."
			})
		} else {
			self.handleDialog('ConfirmUpdateManageUsersResposibilities', true);
		}
    }

	componentWillMount() {
        const { usersOfAccount, userDetails } = this.props.state.user;
		if(!this.props.isEmployeeHasAccessTo('Manage Users') && !(userDetails && userDetails.typeOfUser === "customer" && userDetails.isAdmin)) {
			browserHistory.push("/profile/myProfile");
		}

		const { accountResponsibilityData } = this.props.state.user;
		let { returns, allowedCreditTypes, displaySA } = this.state;
		if (accountResponsibilityData && accountResponsibilityData.responseObject) {
			if(accountResponsibilityData.responseObject.returns) {
				returns = JSON.parse(JSON.stringify(accountResponsibilityData.responseObject)).returns;
			}
			if(accountResponsibilityData.responseObject.allowedCreditTypes) {
				allowedCreditTypes = JSON.parse(JSON.stringify(accountResponsibilityData.responseObject)).allowedCreditTypes;
			}
			if(accountResponsibilityData.responseObject.displaySA) {
				displaySA = JSON.parse(JSON.stringify(accountResponsibilityData.responseObject)).displaySA;
			}
		}
		this.setState({
			usersOfAccount: JSON.parse(JSON.stringify(usersOfAccount)),
			returns,
			displaySA,
			allowedCreditTypes,
		});
    }

	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	handleResponsibilityChange(userId, responsibility, event) {
		const self = this;
		const { usersOfAccount } = self.state;
		const { selectedAccount } = self.props.state.user;
		const checked = event.target.checked;
		usersOfAccount.responseObject.forEach((item, index) => {
			if(item.userId === userId) {
				const indexOfAccount = _.findIndex(item.accounts, { accountNumber: selectedAccount.ACCOUNTNUMBER });
				if(responsibility === "Admin Access") {
					item.accounts[indexOfAccount].admin = checked?"Y":"N";
				} else {
					let responsibilities = item.accounts[indexOfAccount].responsibilities;
					responsibilities = responsibilities?responsibilities:[];
					if(checked) {
						responsibilities.push(responsibility);
					} else {
						if (responsibility === 'Returns/Credits') {
							// For older records which contains Returns so for safer side removing that as well
							// For all new updates it will pass Returns/Credits
							responsibilities.indexOf('Returns') !== -1 && responsibilities.splice(responsibilities.indexOf('Returns'), 1);
						}
						responsibilities.indexOf(responsibility) !== -1 && responsibilities.splice(responsibilities.indexOf(responsibility), 1);
					}
					if((responsibility === 'Price Discounts' || responsibility === "Create New Order" || responsibility === "Edit Orders") && checked) {
						responsibilities.push("Price");
						responsibilities.push("Price Discounts");
					} else if(responsibility === 'Price' && !checked) {
						responsibilities.indexOf('Create New Order') !== -1 && responsibilities.splice(responsibilities.indexOf("Create New Order"), 1);
						responsibilities.indexOf('Price Discounts') !== -1 && responsibilities.splice(responsibilities.indexOf("Price Discounts"), 1);
						responsibilities.indexOf('Edit Orders') !== -1 && responsibilities.splice(responsibilities.indexOf("Edit Orders"), 1);
					} else if(responsibility === 'Price Discounts' && !checked) {
						responsibilities.indexOf('Create New Order') !== -1 && responsibilities.splice(responsibilities.indexOf("Create New Order"), 1);
						responsibilities.indexOf('Edit Orders') !== -1 && responsibilities.splice(responsibilities.indexOf("Edit Orders"), 1);
					}
					responsibilities = _.uniq(responsibilities);
					item.accounts[indexOfAccount] = {
						...item.accounts[indexOfAccount],
						responsibilities: responsibilities.length > 0 ? responsibilities : null
					}
				}
			}
		});
		this.setState({
			usersOfAccount,
			errorMessage: ''
		})
	}

	handleRoleChange = (userId, event) => {
		const {selectedAccount: { ACCOUNTNUMBER: accountNumber}} = this.props.state.user;
		const role = event.target.value;
		const usersOfAccount = JSON.parse(JSON.stringify(this.state.usersOfAccount));

		const user = usersOfAccount.responseObject.find(user => user.userId === userId);
		if (user && user.accounts) {
			const account = user.accounts.find(account => account.accountNumber === accountNumber);
			if (account) {
				account.userRole = role;

				switch (role) {
					case 'buyer':
						account.admin = 'N';
						account.responsibilities = ['Create New Order', 'Edit Orders', 'Invoices and Payments', 'Price', 'Price Discounts', 'Returns/Credits', 'View Orders', 'View Reports'];
						break;
					case 'owner':
						account.admin = 'Y';
						account.responsibilities = ['Create New Order', 'Edit Orders', 'Invoices and Payments', 'Price', 'Price Discounts', 'Returns/Credits', 'View Orders', 'View Reports'];
						break;
					case 'sales':
						account.admin = 'N';
						account.responsibilities = ['Price', 'Price Discounts', 'View Orders'];
						break;
				}

				this.setState({
					usersOfAccount,
					errorMessage: ''
				})
			}
		}
	}

	resetResponsibilities() {
		const { usersOfAccount } = this.props.state.user;
		this.setState({
			usersOfAccount: JSON.parse(JSON.stringify(usersOfAccount))
		});
	}

	handleDeleteClick(deletingUserDetails, event) {
		event.preventDefault();
		this.setState({
			deletingUserDetails
		}, () => {
			this.handleDialog('ConfirmDeleteUserDialogWithOptions', true);
		})
	}

	callBackAfterDeleteAndUpdateUserAccounts() {
		const self = this;
		const { isDeleteCompleted, isUpdateUserAccountCompleted } = self.state;
		if(isDeleteCompleted && isUpdateUserAccountCompleted) {
			self.handleDialog('ConfirmManageUserDeleteUserDialogSuccess', true);
			self.props.saveUsersOfAccount(JSON.parse(JSON.stringify(self.state.usersOfAccount)));
		}
	}
	deleteUser(option, event) {
		event && event.preventDefault();
		const self = this,
			{ deletingUserDetails } = self.state,
			{ selectedAccount, usersOfAccount, userDetails } = self.props.state.user;
		let payload = {
			userId: deletingUserDetails.userId,
			accountNumber: [selectedAccount.ACCOUNTNUMBER],
			userName: `${deletingUserDetails.firstName} ${deletingUserDetails.lastName}`,
			userEmailId: deletingUserDetails.emailAddress,
			deleteType: option,
			adminEmailId: userDetails.email,
		};

		self.handleDialog("ConfirmDeleteUserDialogWithOptions", false);
		self.handleDialog('ConfirmManageUserDeleteUserDialogSuccess', false);

		if(option === 'all') {
			payload.accountNumber = _.filter(deletingUserDetails.accounts, item => item.approvalStatus === "Approved").map(item => item.accountNumber);
		}

		payload.accountNumber = payload.accountNumber.join(',');
		self.props.deleteUser(payload, 'requestType=deleteUser', response => {
			if(response.status) {
				self.setState({
					deleteStatus: response.responseObject,
					isDeleteCompleted: true
				}, () => {
					self.callBackAfterDeleteAndUpdateUserAccounts();
				});
			} else {
				browserHistory.push('/error');
			}
		});

		let accountRequests = [];
		usersOfAccount.responseObject.forEach(item => {
			if(item.userId === deletingUserDetails.userId) {
				item.accounts.forEach(itm => {
					if(option === 'all') {
						itm.approvalStatus = 'Deleted';
						accountRequests.push(itm);
					} else if(itm.accountNumber === selectedAccount.ACCOUNTNUMBER) {
						itm.approvalStatus = 'Deleted';
						accountRequests.push(itm);
					}
				});
			}
		});
		self.setState({
			usersOfAccount
		}, () => {
			self.props.updateUserAccounts(accountRequests, 'requestType=updateAccounts', response => {
				if (response.status) {
					self.setState({
						isUpdateUserAccountCompleted: true
					}, () => {
						self.callBackAfterDeleteAndUpdateUserAccounts();
					});
				} else {
					browserHistory.push('/error');
				}
			});
		});
    }

	handleOtherUserDetails(userDetails, index, event) {
		const self = this;
		event.preventDefault();
		self.setState({
			otherUser: {
				userDetails,
			},
			ldapEmail: null,
			showOtherUserDetails: false,
			selectedIndex: index
		}, () => {
			self.props.getUserLDAPEmail(`userId=${userDetails.userId}&requestType=getUserLDAPEmail`, resp => {
				self.setState({
					ldapEmail: resp && resp.responseObject
				});
			});
			// Fetch all details for other user and then only redirect
			self.props.getOthersUserDetails(`userId=${userDetails.userId}&requestType=getUserDetails`, resp => {
				if(resp.status && resp.responseObject && resp.responseObject.length > 0) {
					self.setState({
						otherUser: {
							...self.state.otherUser,
							getUserDetailsData: resp.responseObject,
							personPartyId: resp.responseObject[0].PERSON_PARTY_ID,
						},
						showOtherUserDetails: true,
					});

					// // get local user details
					// self.props.getOthersLocalUserDetails(`userId=${sso}&requestType=getLocalUser`, response => {
					// 	if(response.status) {
					// 		if(response.responseObject) {
					// 			self.setState({
					// 				localUserDetails: response
					// 			})
					// 		}
					// 	}
					// });
				} else {
					browserHistory.push('/error');
				}
			});
		});
	}

	handleReturnToUserList(event) {
		event.preventDefault();
		this.setState({
			showOtherUserDetails: false,
		});
	}

	updateUsersOfAccountData(emailAddress) {
		const self = this;
		const { selectedIndex } = self.state;
		// Update usersOfAccount in store with updated email id
		const { usersOfAccount } = self.props.state.user;
		usersOfAccount.responseObject[selectedIndex].emailAddress = emailAddress;
		self.props.saveUsersOfAccount(JSON.parse(JSON.stringify(usersOfAccount)));
		const usersOfAccountState = self.state.usersOfAccount;
		usersOfAccountState.responseObject[selectedIndex].emailAddress = emailAddress;
		self.setState({
			usersOfAccount: usersOfAccountState
		});
	}

	onChangeUpdateAllowDealerReturnAccess(event) {
		this.setState({
			returns: event.target.value,
			allowDealerReturnAccessErrorMessage: '',
		});
	}

	onChangeUpdateDisplaySA(event) {
		this.setState({
			displaySA: event.target.value,
			displaySalesAgreementErrorMessage: '',
		});
	}

	onChangeUpdateCreditOptions(event) {
		const self = this;
		let allowedCreditTypes = self.state.allowedCreditTypes;
		if (event.target.checked) {
			allowedCreditTypes.push(event.target.value);
		} else {
			allowedCreditTypes = allowedCreditTypes.filter(item => item !== event.target.value);
		}
		self.setState({
			allowedCreditTypes,
			allowDealerCreditAccessErrorMessage: '',
		});
	}

	handleRequestReturnDealerAccess() {
		const self = this;
		self.setState({
			allowDealerReturnAccessErrorMessage: '',
		});
		const { accountResponsibilityData, userDetails } = this.props.state.user;
		let payload = {};
		// if ther is any responsibility data then need to pass as it is
		if (accountResponsibilityData && accountResponsibilityData.responseObject) {
			payload = accountResponsibilityData.responseObject;
		}
		payload = {
			...payload,
			accountNumber: self.props.getSelectedAccountNumber(),
			returns: self.state.returns,
			updatedBy: userDetails.sso,
			updatedDate: moment().format('MM/DD/YYYY'),
		};
		self.props.updateAccountResponsibility(payload, 'requestType=updateAccountResponsibility', (response) => {
			if(response.status && response.responseObject) {
				let { accountResponsibilityData } = self.props.state.user;
				if (!accountResponsibilityData || !accountResponsibilityData.responseObject) {
					accountResponsibilityData = {
						responseObject: {
							returns: self.state.returns
						}
					}
				} else {
					accountResponsibilityData.responseObject.returns = self.state.returns;
				}
				self.props.saveAccountResponsibility(accountResponsibilityData);
				self.setState({
					genericDialogHeading: 'Success',
					genericDialogText: 'Update has been made successfully.',
				}, () => {
					self.handleDialog('GenericOverlayDialog', true);
				});
			} else {
				self.setState({
					allowDealerReturnAccessErrorMessage: 'Error occured while updating returns access.',
				});
			}
		});
	}

	handleRequestCreditDealerAccess() {
		const self = this;
		self.setState({
			allowDealerCreditAccessErrorMessage: '',
		});
		const { accountResponsibilityData, userDetails } = this.props.state.user;
		let payload = {};
		// if ther is any responsibility data then need to pass as it is
		if (accountResponsibilityData && accountResponsibilityData.responseObject) {
			payload = accountResponsibilityData.responseObject;
		}
		payload = {
			...payload,
			accountNumber: self.props.getSelectedAccountNumber(),
			allowedCreditTypes: self.state.allowedCreditTypes.length === 0 ? null : self.state.allowedCreditTypes,
			updatedBy: userDetails.sso,
			updatedDate: moment().format('MM/DD/YYYY'),
		};
		self.props.updateAccountResponsibility(payload, 'requestType=updateAccountResponsibility', (response) => {
			if(response.status && response.responseObject) {
				let { accountResponsibilityData } = self.props.state.user;
				if (!accountResponsibilityData || !accountResponsibilityData.responseObject) {
					accountResponsibilityData = {
						responseObject: {
							allowedCreditTypes: self.state.allowedCreditTypes
						}
					}
				} else {
					accountResponsibilityData.responseObject.allowedCreditTypes = self.state.allowedCreditTypes;
				}
				self.props.saveAccountResponsibility(accountResponsibilityData);
				self.setState({
					genericDialogHeading: 'Success',
					genericDialogText: 'Update has been made successfully.',
				}, () => {
					self.handleDialog('GenericOverlayDialog', true);
				});
			} else {
				self.setState({
					allowDealerCreditAccessErrorMessage: 'Error occured while updating credits access.',
				});
			}
		});
	}

	handleDisplaySAUpdate() {
		const self = this;
		self.setState({
			displaySalesAgreementErrorMessage: '',
		});
		const { accountResponsibilityData, userDetails } = this.props.state.user;
		let payload = {};
		// if ther is any responsibility data then need to pass as it is
		if (accountResponsibilityData && accountResponsibilityData.responseObject) {
			payload = accountResponsibilityData.responseObject;
		}
		payload = {
			...payload,
			accountNumber: self.props.getSelectedAccountNumber(),
			displaySA: self.state.displaySA,
			updatedBy: userDetails.sso,
			updatedDate: moment().format('MM/DD/YYYY'),
		};
		self.props.updateAccountResponsibility(payload, 'requestType=updateAccountResponsibility', (response) => {
			if(response.status && response.responseObject) {
				let { accountResponsibilityData } = self.props.state.user;
				if (!accountResponsibilityData || !accountResponsibilityData.responseObject) {
					accountResponsibilityData = {
						responseObject: {
							displaySA: self.state.displaySA
						}
					}
				} else {
					accountResponsibilityData.responseObject.displaySA = self.state.displaySA;
				}
				self.props.saveAccountResponsibility(accountResponsibilityData);
				self.setState({
					genericDialogHeading: 'Success',
					genericDialogText: 'Update has been made successfully.',
				}, () => {
					self.handleDialog('GenericOverlayDialog', true);
					self.props.sortyByDisplaySA(self.props.state.user.selectedAccountsAllPriceSources, true);
				});
			} else {
				self.setState({
					displaySalesAgreementErrorMessage: 'Error occured while updating display sales agreement.',
				});
			}
		});
	}

    render() {
		const { usersOfAccount, showOtherUserDetails } = this.state;
		const { userDetails, allowedCreditTypesListForManageUser } = this.props.state.user;
		const sortedUsers = (usersOfAccount && usersOfAccount.responseObject)
			? usersOfAccount.responseObject.slice().sort((a, b) => {
				const { selectedAccount } = this.props.state.user;

				const aAccount = a.accounts.find(
					acc => acc.accountNumber === selectedAccount.ACCOUNTNUMBER && acc.approvalStatus === 'Approved'
				);
				const bAccount = b.accounts.find(
					acc => acc.accountNumber === selectedAccount.ACCOUNTNUMBER && acc.approvalStatus === 'Approved'
				);

				if (!aAccount && !bAccount) return 0;
				if (!aAccount) return 1;
				if (!bAccount) return -1;

				const aIsAdmin = aAccount.admin === "Y";
				const bIsAdmin = bAccount.admin === "Y";

				if (aIsAdmin !== bIsAdmin) {
					return aIsAdmin ? -1 : 1;
				}

				const aName = `${a.firstName} ${a.lastName}`.toLowerCase();
				const bName = `${b.firstName} ${b.lastName}`.toLowerCase();

				return aName.localeCompare(bName);
				})
			: [];

        return (
            <div>
				<ProfileTabs isEmployeeHasAccessTo={this.props.isEmployeeHasAccessTo} selectedTab='manageUsers' />
				{!showOtherUserDetails && <div>
		            {this.state.showConfirmDeleteUserDialogWithOptions?<ConfirmDeleteUserDialogWithOptions userDetails={this.state.deletingUserDetails} deleteUser={this.deleteUser.bind(this)} handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
		            {this.state.showConfirmManageUserDeleteUserDialogSuccess?<ConfirmManageUserDeleteUserDialogSuccess handleDialog={this.handleDialog.bind(this)} showDialog={true} deleteStatus={this.state.deleteStatus} userDetails={this.state.deletingUserDetails} />:null}
		            {this.state.showConfirmUpdateManageUsersResposibilities?<ConfirmUpdateManageUsersResposibilities resetResponsibilities={this.resetResponsibilities.bind(this)} updateDetails={this.updateDetails.bind(this)} handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}

		            {/* This element is OPTIONAL. */}
	            	<p className="importantText bold hide">Updates have been saved.</p>
	            	<h2>Account {this.props.state.user.selectedAccount.ACCOUNTNUMBER}&nbsp;— All Users</h2>
		            {/* ********************************************************************** */}
		            {/* NOTE: clicking a "Delete" link opens a dialog window.
		                    In that dialog, the "Yes" button also triggers submission of this form. */}
		            {/* ********************************************************************** */}
		            {this.state.updateMessage?<p className="importantText bold">Updates have been saved.</p>:null}
					<p className="red bold">{this.state.errorMessage}</p>
	                <div className="dataTableContainer">
	                    <table className="dataTable manageUsersFormTable">
	                        <thead>
	                            <tr>
	                                <th>Select user to see all accounts tied to that user</th>
	                                <th>Price</th>
	                                <th>Price Discounts</th>
	                                <th>View Orders</th>
	                                <th>Create New Order</th>
	                                <th>Edit Orders</th>
	                                <th>Returns/<br/>Credits</th>
	                                <th>Invoices and Payments</th>
									<th>View Reports</th>
	                                <th className="yellowHighlight">Manage Users <i>(Account Administrator)</i></th>
									<th>Role</th>
	                                <th>Delete User</th>
	                            </tr>
	                        </thead>
	                        <tbody>
	                            {sortedUsers && sortedUsers.map((item, index) => {
									const { userDetails, selectedAccount } = this.props.state.user;
									const accountIndex = _.findIndex(item.accounts, {accountNumber: selectedAccount.ACCOUNTNUMBER, approvalStatus: 'Approved'});
									if(accountIndex === -1) {
										return null
									}
									
									const userRole = item.accounts[accountIndex].userRole;
									let responsibilities = item.accounts[accountIndex].responsibilities;
									responsibilities = responsibilities?responsibilities:[];
									return <tr key={index}>
										<td><a onClick={this.handleOtherUserDetails.bind(this, item, index)} href="">{item.firstName+' '+item.lastName}</a></td>
										<td><input type="checkbox" onChange={this.handleResponsibilityChange.bind(this, item.userId, 'Price')} checked={responsibilities.indexOf('Price') !== -1 ? true : false} disabled={userRole} /></td>
										<td><input type="checkbox" onChange={this.handleResponsibilityChange.bind(this, item.userId, 'Price Discounts')} checked={responsibilities.indexOf('Price Discounts') !== -1 ? true : false} disabled={userRole} /></td>
										<td><input type="checkbox" onChange={this.handleResponsibilityChange.bind(this, item.userId, 'View Orders')} checked={responsibilities.indexOf('View Orders') !== -1 ? true : false} disabled={userRole} /></td>
										<td><input type="checkbox" onChange={this.handleResponsibilityChange.bind(this, item.userId, 'Create New Order')} checked={responsibilities.indexOf('Create New Order') !== -1 ? true : false} disabled={userRole} /></td>
										<td><input type="checkbox" onChange={this.handleResponsibilityChange.bind(this, item.userId, 'Edit Orders')} checked={responsibilities.indexOf('Edit Orders') !== -1 ? true : false} disabled={userRole} /></td>
										<td><input type="checkbox" onChange={this.handleResponsibilityChange.bind(this, item.userId, 'Returns/Credits')} checked={(responsibilities.indexOf('Returns') !== -1 || responsibilities.indexOf('Returns/Credits') !== -1) ? true : false} disabled={userRole} /></td>
										<td><input type="checkbox" onChange={this.handleResponsibilityChange.bind(this, item.userId, 'Invoices and Payments')} checked={responsibilities.indexOf('Invoices and Payments') !== -1 ? true : false} disabled={userRole} /></td>
										<td><input type="checkbox" onChange={this.handleResponsibilityChange.bind(this, item.userId, 'View Reports')} checked={responsibilities.indexOf('View Reports') !== -1 ? true : false} disabled={userRole} /></td>
										<td className="yellowHighlight"><input type="checkbox" onChange={this.handleResponsibilityChange.bind(this, item.userId, 'Admin Access')} checked={item.accounts[accountIndex].admin === "Y"} disabled={userRole || (item.userId !== this.props.state.user.userDetails.sso ? false : true)} /></td>
										<td className="small">
											{userRole && <select value={userRole} onChange={this.handleRoleChange.bind(this, item.userId)}>
												{PNET_USER_ROLES.map((option) => <option key={option.value} value={option.value}>{option.label}</option>)}
											</select>}
										</td>
										<td>{item.userId !== userDetails.sso ? <a className="deleteUserLink" onClick={this.handleDeleteClick.bind(this, item)} href="#">Delete</a> : null}</td>
									</tr>
								})}
	                        </tbody>
	                    </table>
	                </div>
	                <p className="textRight">
	                    <input className="blueButton" type="submit" onClick={this.updateAccount.bind(this)} value="Update" />
	                </p>
					{userDetails.typeOfUser === "employee" && <div>
						{this.state.displaySalesAgreementErrorMessage && <p className="red bold">{this.state.displaySalesAgreementErrorMessage}</p>}
						<div className="bold">Display Sales Agreements:</div>
						<div className="radio-style">
							<label htmlFor="drop_date-one1" className="bold">
								<input id="drop_date-one1" name="displaySA" value="Alphabetically" type="radio" defaultChecked={this.state.displaySA === 'Alphabetically'} onClick={this.onChangeUpdateDisplaySA.bind(this)} />
									Alphabetically
							</label>
						</div>
						<div className="radio-style">
							<label htmlFor="drop_date-one2" className="bold">
								<input id="drop_date-one2" name="displaySA" value="Numerically" type="radio" defaultChecked={this.state.displaySA === 'Numerically'} onClick={this.onChangeUpdateDisplaySA.bind(this)} />
									Numerically
							</label>
						</div>
						<p className="update-button-padding">
		                    <input className="blueButton" type="submit" onClick={this.handleDisplaySAUpdate.bind(this)} value="Update" />
		                </p>
					</div>}
					<br />
					{userDetails.typeOfUser === "employee" && <div>
						{this.state.allowDealerReturnAccessErrorMessage && <p className="red bold">{this.state.allowDealerReturnAccessErrorMessage}</p>}
						<div className="bold">Allow Customer to Enter Returns:</div>
						<div className="radio-style">
							<label htmlFor="drop_date-one3" className="bold">
								<input id="drop_date-one3" name="returns" value="No" type="radio" defaultChecked={this.state.returns === 'No'} onClick={this.onChangeUpdateAllowDealerReturnAccess.bind(this)} />
									No Returns
							</label>
						</div>
						<div className="radio-style">
							<label htmlFor="drop_date-one4" className="bold">
								<input id="drop_date-one4" name="returns" value="ASMApprovalRequired" type="radio" defaultChecked={this.state.returns === 'ASMApprovalRequired'} onClick={this.onChangeUpdateAllowDealerReturnAccess.bind(this)} />
									Returns with ASM Approval
							</label>
						</div>
						<div className="radio-style">
							<label htmlFor="drop_date-one5" className="bold">
								<input id="drop_date-one5" name="returns" value="NoApprovalRequired" type="radio" defaultChecked={this.state.returns === 'NoApprovalRequired'} onClick={this.onChangeUpdateAllowDealerReturnAccess.bind(this)} />
									Returns without Approval
							</label>
						</div>
						<p className="update-button-padding">
		                    <input className="blueButton" type="submit" onClick={this.handleRequestReturnDealerAccess.bind(this)} value="Update" />
		                </p>
						{this.state.showGenericOverlayDialog?<GenericOverlayDialog genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons="ok" flag="GenericOverlayDialog" handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
					</div>}
					<br />
					{userDetails.typeOfUser === "employee" && <div>
						{this.state.allowDealerCreditAccessErrorMessage && <p className="red bold">{this.state.allowDealerCreditAccessErrorMessage}</p>}
						<div className="bold">Allow Customer to Request Credits. All Credits require ASM Approval.</div>
						{allowedCreditTypesListForManageUser.map((item, index) => {
							return <div className="radio-style" key={index}>
								<label htmlFor="drop_date-one6" className="bold">
									<input id="drop_date-one6" checked={this.state.allowedCreditTypes.find(itm => itm === item) ? true : false} name={item} value={item} type="checkbox" onClick={this.onChangeUpdateCreditOptions.bind(this)} />
										{item}
								</label>
							</div>
						})}
						<p className="update-button-padding">
		                    <input className="blueButton" type="submit" onClick={this.handleRequestCreditDealerAccess.bind(this)} value="Update" />
		                </p>
					</div>}
				</div>}
				{/* Other user details start */}
				{showOtherUserDetails && <div>
					<p className="bold">
						<a href="" onClick={this.handleReturnToUserList.bind(this)}>&lt; Return to User List</a>
					</p>
					<OtherUserMyProfile
						getAddressesByCategory={ this.props.getAddressesByCategory }
						isResponsibilityExists={ this.props.isResponsibilityExists }
						isThisAccountRestricted={ this.props.isThisAccountRestricted }
						ldapEmail={ this.state.ldapEmail }
						isAdmin={this.props.state.user.userDetails.isAdmin}
						updateUsersOfAccountData={this.updateUsersOfAccountData}
						{...this.state.otherUser}
						typeOfAccount={this.props.getSelectedAccountType()}
					/>
				</div>}
				{/* Other user details end */}
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {state};
};

const mapDispatchToProps = (dispatch) => ({
	saveUsersOfAccount: (data) => dispatch(saveUsersOfAccount(data)),
	saveAccountResponsibility: (data) => dispatch(saveAccountResponsibility(data)),
	getOthersUserDetails: (payload, callback) => dispatch(getOthersUserDetails(payload, callback)),
	// getOthersLocalUserDetails: (payload, callback) => dispatch(getOthersLocalUserDetails(payload, callback)),
	deleteUser: (payload, hybridQueryParams, callback) => dispatch(deleteUser(payload, hybridQueryParams, callback)),
	updateUserAccounts: (payload, hybridQueryParams, callback) => dispatch(updateUserAccounts(payload, hybridQueryParams, callback)),
	updateAccountResponsibility: (payload, hybridQueryParams, callback) => dispatch(updateAccountResponsibility(payload, hybridQueryParams, callback)),
	getUserLDAPEmail: (queryStringParams, callback) => dispatch(getUserLDAPEmail(queryStringParams, callback)),
});

ManageUsers = connect(mapStateToProps, mapDispatchToProps)(ManageUsers);
export default ManageUsers;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Profile/ManageUsers.js